import React from 'react';
import { Link } from 'react-router-dom';

const LoginSection: React.FC = () => {
  return (
    <div className="md:hidden bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
          Log in to see your account details
        </h2>
        <p className="text-lg text-black mb-8 max-w-2xl mx-auto">
          View past trips, tailored suggestions, support resources and more.
        </p>
        
        <Link 
          to="/account"
          className="inline-block bg-black text-white font-semibold px-8 py-4 rounded-lg hover:bg-gray-800 transition-colors duration-200"
        >
          Log in to your account
        </Link>
      </div>
    </div>
  );
};

export default LoginSection;